import { render, staticRenderFns } from "./autoAddTag.vue?vue&type=template&id=90daa428&scoped=true"
import script from "./autoAddTag.vue?vue&type=script&lang=js"
export * from "./autoAddTag.vue?vue&type=script&lang=js"
import style0 from "./autoAddTag.vue?vue&type=style&index=0&id=90daa428&prod&lang=less&scoped=true"
import style1 from "./autoAddTag.vue?vue&type=style&index=1&id=90daa428&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90daa428",
  null
  
)

export default component.exports